// src/modules/app-views/invoices/pages/Init/components/tableColumns/documentNumberColumn.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { Tooltip, Typography } from 'antd';
import translateX from 'utils/translateX';
import invoicesService from 'modules/app-views/invoices/service';
import { returnOnlyNumbers } from 'utils/helpers';

const { Text } = Typography;

// *******************************************************************************
// GLOBAL VARIABLES
// *******************************************************************************

const blockStyle = { display: 'block' };
const lcStyle = { fontSize: 12 };

// *******************************************************************************
// COLUMN FUNCTION
// *******************************************************************************

// Renders documentNumber-documentSerie with accessKey tooltip.
// options.requireSefaz: true (default, invoices) — hides number if not processed by SEFAZ.
//                       false (goodsReceipt) — always shows number.
function documentNumberColumn(buildColumnProps, options = {}) {
  const {
    searchPlaceholder = 'invoice_or_access_key',
    requireSefaz = true,
    search = true,
  } = options;

  return {
    title: translateX('number'),
    dataIndex: 'documentNumber',
    ...buildColumnProps('documentNumber', { sort: true, search, searchPlaceholder }),
    width: 130,
    render: (_, record) => {
      const serie = record?.documentSerie || 1;
      const number = record?.documentNumber || null;
      const isProcessed = requireSefaz ? invoicesService.isProcessedBySefaz(record?.status) : true;
      const displayNumber = !isProcessed ? '—' : number ? `${returnOnlyNumbers(number)}-${serie}` : '—';
      const legacyCode = record?.legacyCode;
      const lcValue = Array.isArray(legacyCode) ? legacyCode.join(',') : legacyCode;

      return (
        <Tooltip title={record?.accessKey}>
          <div>
            <Text ellipsis strong style={blockStyle}>
              {displayNumber}
            </Text>
            {lcValue && (
              <Text type="secondary" style={lcStyle}>
                LC: {lcValue}
              </Text>
            )}
          </div>
        </Tooltip>
      );
    },
  };
}

export default documentNumberColumn;
